var selected_carroussel_id;
var selected_carroussel_src;
var selected_carroussel_index;
var carr_swiper_instance;

//USER CATALOG PAGE 
document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementById('user_catalog_carroussel')) {
        console.log('Initializing catalog carroussel...');
        const swiper = carr_swiper_instance = new Swiper("#user_catalog_carroussel", {
            loop: true,
            grabCursor: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            speed: 500
        });

        if (swiper.slides.length <= 1) {
            swiper.navigation.disable();
        } 

        swiper.on("slideChange", () => {
            //START VIDEO
            document.querySelectorAll(".swiper-slide video").forEach(v => {
                v.pause();
                v.currentTime = 0;
            });

            const activeSlide = swiper.slides[swiper.activeIndex];
            if (activeSlide) {
                const video = activeSlide.querySelector("video");
                if (video) {
                    video.loop = true;
                    video.muted = true;
                    video.setAttribute("playsinline", "true");
                    video.play().catch(() => { });
                }
            }
        });

        swiper.on('click', (swiperInstance, event) => {
            const clickedIndex = swiper.clickedIndex;
            if (clickedIndex === undefined || clickedIndex === null) return;

            const container = document.querySelector('.sec-carr-mid');
            container.classList.add('border-animate');
            setTimeout(() => {
                container.classList.remove('border-animate');
            }, 600);

            const clickedSlide = swiper.slides[clickedIndex];
            if (clickedSlide) {
                const media = clickedSlide.querySelector('img, video');
                if (media) {
                    selected_carroussel_id = media.getAttribute('id');
                    selected_carroussel_index = clickedIndex;
                    $('.rm-alt').removeClass('hide');
                }
            }
        });
    }
});

// HOME CARRUOSEL PAGE
document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementById('home_carroussel')) {
        console.log('Initializing home carroussel...');
        const swiper = new Swiper("#home_carroussel", {
            loop: true,
            grabCursor: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            speed: 500,
            autoplay: { delay: carrousselInterval, disableOnInteraction: false }
        });

        if (swiper.slides.length <= 1) {
            swiper.navigation.disable();
        } 

        function playActiveVideo() {
            document.querySelectorAll(".swiper-slide video").forEach(v => {
                v.pause();
                v.currentTime = 0;
            });

            const activeSlide = swiper.slides[swiper.activeIndex];
            const video = activeSlide.querySelector("video");
            if (video) {
                video.loop = true;
                video.muted = true; 
                video.setAttribute("playsinline", "true");
                video.play().catch(() => { });
            }
        }

        swiper.on("init", playActiveVideo);
        swiper.on("slideChange", playActiveVideo);
        swiper.on('click', (swiperInstance, event) => {
            const clickedIndex = swiper.clickedIndex;
            if (clickedIndex === undefined || clickedIndex === null) return;

            const clickedSlide = swiper.slides[clickedIndex];
            if (clickedSlide) {
                const media = clickedSlide.querySelector('img, video');
                if (media) {
                    var target = media.getAttribute('target');
                    var targetType = media.getAttribute('targetType');
                    carr_redirect(target, targetType);
                }
            }
        });

        swiper.init();
    }
});

// HOME PRODUCT 
function loadProductCarroussel() {
    if (document.getElementById('home_product_carroussel')) {
        console.log('Initializing product carroussel...');
        const swiper = new Swiper("#home_product_carroussel", {
            loop: false,
            grabCursor: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            speed: 500
        });

        setTimeout(() => {
            swiper.on("slideChange", setActiveSlide);
            setActiveSlide();
        }, 200);

        if (swiper.slides.length <= 1) {
            swiper.navigation.disable();
        } 

        function setActiveSlide() {
            const activeSlide = swiper.slides[swiper.activeIndex];
            if (activeSlide) {
                const media = activeSlide.querySelector('img, video');
                if (media) {
                    selected_carroussel_id = media.id;
                    selected_carroussel_src = media.getAttribute('src');
                }
            }
        }
    }
}

//HOME ABS PRODUCT
function loadProductFullscreenCarroussel() {
    var container = document.getElementById('home_product_fullscreen_carroussel');
    if (container) {
        console.log('Initializing fulscreen carroussel...');
        const swiper = new Swiper("#home_product_fullscreen_carroussel", {
            loop: false,
            grabCursor: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: false
            },
            speed: 500
        });

        if (swiper.slides.length <= 1) {
            swiper.navigation.disable();
        } 

        container.addEventListener('click', function (e) {
            var abs = document.getElementsByClassName('imageFocusAbsolute')[0];
            if (abs) {
                var media = document.querySelectorAll('#home_product_fullscreen_carroussel img, #home_product_fullscreen_carroussel video, .swiper-button-next, .swiper-button-prev');
                var isInsideMedia = Array.from(media).some(el => el.contains(e.target));
                if (!isInsideMedia) {
                    abs.remove();
                }
            }
        });
    }
}


//MISC
function carr_redirect(target, targetType) {
    switch (targetType) {
        case "SECTION":
            window.location.href = `/Home?hfty=${TableID}&y=${target}`;
            break;
        case "PRODUCT":
            var parms = target.split(';');  
            window.location.href = `/Home/Product?hfty=${TableID}&y=${parms[1]}&p=${parms[0]}`;
            break;
        case "CART":
            window.location.href = `/Home/Cart?hfty=${TableID}`;
            break;
        case "CHECKOUT":
            window.location.href = `/Home/Checkout?hfty=${TableID}`;
            break;
        case "EXTERNAL_LINK":
            openNewTab(target);
            break;
        default:
            break;
    }
}